import React from 'react';

import { FlatenedCategory } from '@lumapps/learning-catalog/types';
import { CatalogCategoryPickerField } from '@lumapps/learning-pickers/components/CatalogCategoryPickerField';
import { FlexBox, Orientation, Switch } from '@lumapps/lumx/react';
import { useSelector } from '@lumapps/redux/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { currentLanguageSelector } from '@lumapps/translations/ducks/selectors';

import { LearningCatalogSettingsProps } from '../../types';

export const LearningCatalogSettings: React.FC<LearningCatalogSettingsProps> = ({ properties, onChange }) => {
    const { translateKey } = useTranslate();
    const locale = useSelector(currentLanguageSelector);
    const [choice, setChoice] = React.useState<FlatenedCategory>();

    const handleOnChange = (flatenedCategory?: FlatenedCategory) => {
        setChoice(flatenedCategory);
        onChange({
            categoryTitle: flatenedCategory?.categoryData.title ?? '',
            categoryCode: flatenedCategory?.categoryData.code ?? '',
        });
    };

    const handleSearchToggle = (isChecked: boolean) => {
        onChange({ isSearchHidden: !isChecked });
    };

    return (
        <FlexBox orientation={Orientation.vertical}>
            <Switch isChecked={!properties?.isSearchHidden} onChange={handleSearchToggle}>
                {translateKey(GLOBAL.SEARCH_FIELD)}
            </Switch>

            <CatalogCategoryPickerField
                locale={locale}
                label={translateKey(GLOBAL.CATEGORY)}
                value={choice}
                onChange={handleOnChange}
            />
        </FlexBox>
    );
};
